var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9269 18.5418C21.9269 18.3629 21.8495 18.1927 21.7146 18.0751V18.0751C21.1124 17.5448 20.5852 16.9368 20.1475 16.2674C19.6694 15.3435 19.3828 14.3345 19.3046 13.2997V10.2519C19.3087 8.6266 18.7121 7.05572 17.6268 5.83443C16.7175 4.81118 15.5175 4.09236 14.1927 3.76499C13.7512 3.65589 13.4107 3.27847 13.4107 2.82365V2.82365C13.4107 2.6052 13.3228 2.39571 13.1665 2.24124C13.0102 2.08678 12.7982 2 12.5771 2C12.3561 2 12.1441 2.08678 11.9878 2.24124C11.8314 2.39571 11.7436 2.6052 11.7436 2.82365V2.82365C11.7436 3.2867 11.3993 3.67191 10.9511 3.78836C9.64641 4.12739 8.46781 4.84708 7.5745 5.86228C6.50345 7.07946 5.91508 8.63896 5.91837 10.2519V13.2997C5.84017 14.3345 5.55361 15.3435 5.07549 16.2674C4.64523 16.9351 4.12659 17.5431 3.53333 18.0751V18.0751C3.39845 18.1927 3.32104 18.3629 3.32104 18.5418V19C3.32104 19.5523 3.76876 20 4.32104 20H20.9269C21.4792 20 21.9269 19.5523 21.9269 19V18.5418Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7271 21C10.1012 21 9.65151 21.5956 10.0894 22.0428C10.2275 22.1838 10.3877 22.3138 10.5676 22.4299C11.1376 22.7975 11.868 23 12.6239 23C13.3799 23 14.1103 22.7975 14.6803 22.4299C14.8602 22.3138 15.0203 22.1838 15.1584 22.0428C15.5963 21.5956 15.1466 21 14.5207 21H10.7271Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.dfffe222140a26fbb23d5b82355d9d6d.svg";
export { ForwardRef as ReactComponent };